import WarpElement from "@warp-ds/elements-core";
import { SearchFilter } from "../../../models/filters.js";
import { css, html } from "lit";
import { Subvertical } from "../../../constants.js";

class MakeLinks extends WarpElement {
    declare makeModelLinks: SearchFilter[];
    declare subvertical: Subvertical;
    declare makesToShow: number;

    static styles = [
        WarpElement.styles,
        css`
            @css-placeholder-W4CS1k;
        `,
    ];

    static properties = {
        makeModelLinks: { type: Array },
        subvertical: { type: String },
        showMoreMakes: { type: Boolean },
        makesToShow: { type: Number },
    };

    constructor() {
        super();
    }

    connectedCallback() {
        super.connectedCallback();
    }

    render() {
        return html`<ul id="${this.subvertical}-make-list" class="grid md:grid-cols-5 grid-cols-2 md:gap-x-56 gap-x-24 gap-y-8">
            ${this.makeModelLinks.map(({ title }, index) => {
                const titleText = typeof title === "string" ? title : title.displayName;
                const titleUrl = typeof title === "string" ? "" : title.url;
                return html`<li class="${index >= this.makesToShow ? "hidden" : ""}">
                    <a href="${titleUrl}" class="s-text s-text-subtle">${titleText}</a>
                </li>`;
            })}
        </ul>`;
    }
}

customElements.define("mfp-make-links", MakeLinks as unknown as CustomElementConstructor);
